import { useRecoilCallback } from 'recoil';
import type { CombinePortfoliosOrganizeOptionEnum } from 'venn-api';
import {
  aggregatedGroupingState,
  allocatorAnalysisSubject,
  originalAnalysisSubjectQuery,
  portfolioSubject,
  rebuildAggregatedPortfolio,
} from 'venn-state';
import { AnalysisSubject } from 'venn-utils';

type SetAggregatedGroupingFunction = (portfolioId: number, organizeOption: CombinePortfoliosOrganizeOptionEnum) => void;

export const useSetAggregatedGrouping = (): SetAggregatedGroupingFunction =>
  useRecoilCallback(
    ({ snapshot, set }) =>
      async (portfolioId, organizeOption) => {
        // Persist the selection (saves with the view + drives the dropdown's selected value).
        set(aggregatedGroupingState(portfolioId), organizeOption);

        const subject = portfolioSubject(portfolioId);
        const current = await snapshot.getPromise(originalAnalysisSubjectQuery(subject));
        const portfolio = current?.portfolio;
        if (!current || !portfolio) {
          return;
        }
        const rebuilt = await rebuildAggregatedPortfolio(portfolio, current.proxySetId, organizeOption);
        if (!rebuilt) {
          return;
        }
        set(
          allocatorAnalysisSubject(subject),
          new AnalysisSubject(rebuilt, 'portfolio', current.proxySetId, {
            ...current.getOptionsCopy(),
            isAggregatedPortfolio: true,
          }),
        );
      },
    [],
  );
